* {
    box-sizing: border-box;
    min-width: 0;
}

:host(limel-dynamic-label) {
    --limel-dynamic-label-min-height: 1.75rem;
    display: flex;
    gap: 0.25rem;
    align-items: flex-start;
    border-radius: 0.5rem;
    min-width: 0;
}

limel-icon {
    --limel-icon-svg-margin: 0.125rem;
    border-radius: 0.25rem;
    flex-shrink: 0;
    width: var(--limel-dynamic-label-min-height);
    color: rgb(
        var(--contrast-900)
    ); // The default `false` color. Will be overwritten by `Icon`
}

label {
    flex-grow: 1;
    font-size: var(
        --limel-theme-default-small-font-size
    ); // `13px`, Like Checkbox & Switch
    line-height: normal;
    color: var(--limel-theme-on-surface-color);
    padding-top: 0.375rem;
}
